export const CHANGE_CURRENT_PAGE = "CHANGE_CURRENT_PAGE";
export const CHANGE_SORT = "CHANGE_SORT";
export const CHANGE_SEARCH_STRING = "CHANGE_SEARCH_STRING";
export const CHANGE_ITEMS_PER_PAGE = "CHANGE_ITEMS_PER_PAGE";
